import { useQuery } from "react-query";
import { getReferrals } from "../api/user/getReferrals";

export const REFERRALS_QUERY_KEY = "referrals";

export const useQueryGetReferrals = () =>
  useQuery([REFERRALS_QUERY_KEY], getReferrals);
